"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenAPIValidationError = void 0;
const codes_1 = require("../codes");
const isOpenAPIValidationError = (arg) => {
    return (typeof arg === 'object' &&
        arg !== null &&
        'code' in arg &&
        arg.code === codes_1.OPENAPI_VALIDATION_ERROR &&
        'status' in arg &&
        arg.status === 400);
};
exports.isOpenAPIValidationError = isOpenAPIValidationError;
